/*
 * jQuery doTimeout: Like setTimeout, but better! - v1.0 - 3/3/2010
 * http://benalman.com/projects/jquery-dotimeout-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($){var a={},c="doTimeout",d=Array.prototype.slice;$[c]=function(){return b.apply(window,[0].concat(d.call(arguments)))};$.fn[c]=function(){var f=d.call(arguments),e=b.apply(this,[c+f[0]].concat(f));return typeof f[0]==="number"||typeof f[1]==="number"?this:e};function b(l){var m=this,h,k={},g=l?$.fn:$,n=arguments,i=4,f=n[1],j=n[2],p=n[3];if(typeof f!=="string"){i--;f=l=0;j=n[1];p=n[2]}if(l){h=m.eq(0);h.data(l,k=h.data(l)||{})}else{if(f){k=a[f]||(a[f]={})}}k.id&&clearTimeout(k.id);delete k.id;function e(){if(l){h.removeData(l)}else{if(f){delete a[f]}}}function o(){k.id=setTimeout(function(){k.fn()},j)}if(p){k.fn=function(q){if(typeof p==="string"){p=g[p]}p.apply(m,d.call(n,i))===true&&!q?o():e()};o()}else{if(k.fn){j===undefined?e():k.fn(j===false);return true}else{e()}}}})(jQuery);

// Jake Library 


function jakesInfiniteScroll() {
 if($(document).height() - 1200 < ($(document).scrollTop() + $(window).height())) {
     scrollNode = $('.more').last();    
     scrollURL = $('.more p a').last().attr("href");
     if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
         console.log("infinite requesting...");
         $.ajax({
             type: 'GET',
             url: scrollURL,
             beforeSend: function() {
               scrollNode.hide();
               $('.more').hide(); // HACK don't know why above isnt' working
               $(".loading-spinner-wrapper").show()
             },
             success: function(data) {
                console.log("infinite success...");
               // remove loading feedback
               scrollNode.remove();
               $('.more').remove(); // HACK don't know why remove isnt' working
               var filteredData = $(data).find(".jake--product-grid").contents();
               filteredData.appendTo($(".jake--product-grid") );     

               var nextPageMore = $(data).find(".more");
               nextPageMore.appendTo( $(".pagination") );

               // Register only new cards; syncing existing cards can capture opacity: 0.
               if (window.sr) {
                 window.sr.reveal(filteredData.find('.product-card-top').get(), {
                   interval: theme.intervalValue
                 });
               }

               $(".loading-spinner-wrapper").hide();
               $(".grid--view-items").css("margin-bottom", '0px');
             },
             dataType: "html"
         });
     }
 }  
}

$(document).ready(function() {
  console.log("infinite ready");
  $(document).scroll(function () {
    $.doTimeout("scroll", 0, jakesInfiniteScroll);
  });



  // BRANDS on mobile auto expand them on mobile
  // Find all anchor tags within the specified namespace
  const links = document.querySelectorAll(".mobile-draw__wrapper a");

  // Filter out the specific link with the text "Brands"
  const brandsLink = Array.from(links).find(
    (link) => link.textContent.trim().toLowerCase() === "brands"
  );

  // Check if the brands link exists and add the event listener
  if (brandsLink) {
    brandsLink.addEventListener("click", function () {
      // Select all sub-menu toggle links within the .mobile-draw__wrapper
      const subToggleLinks = document.querySelectorAll(
        ".mobile-draw__wrapper .mobile-nav__sub__link--t.js-toggle-trigger"
      );

      // Trigger a click event on each sub-menu toggle link if it does not have the 'js-active' class
      subToggleLinks.forEach((link) => {
        if (!link.classList.contains("js-active")) {
          link.click(); // Simulate a click to expand the submenu
        }
      });
    });
  }
  // END BRANDS on mobile auto expand them on mobile

  
});
